module.exports = __webpack_public_path__ + "img/654.7db5f980.png";